import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import RadioGroup from "./RadioGroup";
import { EXTERNAL_ROLES, roleTypeToId } from "../../../utils/Roles";

const RoleRadioGroup = (props, context) => {
    const {
        input,
        label,
        meta,
        radios,
        groupClassName,
        onChange,
        id,
        disabled,
        required,
    } = props;

    const { touched, error } = meta;
    const validationState = touched && !!error ? error.state : null;
    const validationMessageKey = !!error && error.messageKey ? error.messageKey : null;
    const validationValues = !!error && error.values ? error.values : null;
    const scene = context.scene ? "-" + context.scene : "";

    const externalRoleIds = roleTypeToId(EXTERNAL_ROLES);

    const internalRadios = radios.filter((r) => !externalRoleIds.includes(r.value));
    const externalRadios = radios.filter((r) => externalRoleIds.includes(r.value));

    
    const sharedProps = {
        input,        
        meta,
        disabled,
        onChange,
        id,
        required: false,
        hideError:true,
    };

    return (
        <FormGroup
            className={groupClassName}
            controlId={id + scene}
            validationState={validationState}
        >
            {label && (
                <ControlLabel>
                    {label} {required ? <span className="required"> *</span> : ""}
                </ControlLabel>
            )}

           
            <div className="role-group">
                <span className="role-group-title">
                    <FormattedMessage id="admin.users.form.RoleInternal" />
                </span>
                <RadioGroup
                    {...sharedProps}
                    radios={internalRadios}
                />
            </div>

            <div className="role-group">
                <span className="role-group-title">
                    <FormattedMessage id="admin.users.form.RoleExternal" />
                </span>
                <RadioGroup
                    {...sharedProps}
                    radios={externalRadios}
                />
            </div>

            {touched && error && (
                <HelpBlock>
                    <FormattedMessage id={validationMessageKey} values={validationValues} />
                </HelpBlock>
            )}
        </FormGroup>
    );
};

RoleRadioGroup.propTypes = {
    disabled: PropTypes.bool,
    groupClassName: PropTypes.string,
    id: PropTypes.string,
    input: PropTypes.object.isRequired,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onChange: PropTypes.func,
    meta: PropTypes.object.isRequired,
    radios: PropTypes.array.isRequired,
    required: PropTypes.bool,
};

RoleRadioGroup.contextTypes = {
    intl: intlShape,
};

export default RoleRadioGroup;


// WEBPACK FOOTER //
// ./src/components/common/form/RoleRadioGroup.js